import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AllocationType } from '../models/Accounts';
import { IUserInfo, AvailableLanguageLocale } from '../models/UserInfo';

export const useUserAddress = (userInfo: IUserInfo, selectedLanguage: string) => {
  const { t } = useTranslation();
  const [userAddress, setUserAddress] = useState('');

  useEffect(() => {
    if (userInfo.Addresses.length > 0) {
      const locale = (selectedLanguage[0].toUpperCase() + selectedLanguage.slice(1)) as AvailableLanguageLocale;
      const locationTypeId = userInfo.Addresses[0].LocationType.id;

      const getFlatNumber = (typeId: AllocationType) => {
        switch (typeId) {
          case AllocationType.FLAT: {
            return `${t('userInfo.apt')} ${userInfo.Addresses[0].Flat}`;
          }
          case AllocationType.OFFICE: {
            return `${t('userInfo.office')} ${userInfo.Addresses[0].Flat}`;
          }
          case AllocationType.SEPARATE_BUILDING: {
            return `${t('userInfo.apt')} ${userInfo.Addresses[0].Flat}`;
          }
          default: {
            return '';
          }
        }
      };

      const flat = getFlatNumber(locationTypeId);
      const userStreet = userInfo.Addresses[0]?.Street[`Name${locale}`];
      const house =
        locationTypeId === AllocationType.PRIVATE_HOUSE
          ? ` ${userInfo.Addresses[0].Flat}`
          : ` ${userInfo.Addresses[0].House},`;
      const address = `${userStreet} ${house} ${flat}`;
      setUserAddress(address);
    }
  }, [selectedLanguage, userInfo]);

  return { userAddress };
};
